class _Loader{
    constructor() {
        this.__organizationFormsSettings = null;
    }

    async load(){
        this.__organizationFormsSettings = await Rpc.plm.services.CompanyConfigurationService.findSettingsForOrganizationFieldsAndForms();
    }

    getConfig(){
        return this.__organizationFormsSettings;
    }
}

const CompanyConfigurationFormsLoader = new _Loader();
export default CompanyConfigurationFormsLoader;